import React, { useState } from "react";
import classes from "./setWorkersButton.module.scss";
import EditWorkersList from "../../../modal/EditWorker/EditWorkersList";
import { userState } from "../../../../states/userState";
import { useRecoilValue } from "recoil";
import { Worker } from "../../../../types";
const SetWorkersButton = () => {
  const [isShowEditWorkersList, setIsShowEditWorkersList] = useState(false);
  const user = useRecoilValue(userState);
  const workerList = user.initialParameters.workersForList;
  return (
    <>
      <div
        className={classes.container}
        onClick={() => setIsShowEditWorkersList(true)}
      >
        <p>
          {workerList.map((worker: Worker, index: number) => {
            let workerName;
            if (index !== workerList.length - 1) {
              workerName = worker.workerName + ",";
            } else {
              workerName = worker.workerName;
            }
            return workerName;
          })}
        </p>
      </div>
      {isShowEditWorkersList && (
        <EditWorkersList setIsShow={setIsShowEditWorkersList} />
      )}
    </>
  );
};

export default SetWorkersButton;
